<template>
<div class="sortable"
  @click="changeSort">
  <span>{{name}}</span>
  <span class="icon is-medium"><i class="material-icons md-24">{{icon}}</i></span>
</div>
</template>

<script>
export default {
  props: ['name', 'field', 'params'],
  computed: {
    icon() {
      if (this.field === this.params.sort) {
        return this.params.direction === '1' ? 'keyboard_arrow_down' : 'keyboard_arrow_up'
      }
      return false
    }
  },
  methods: {
    changeSort() {
      if (this.field === this.params.sort) {
        this.params.direction = this.params.direction === '1' ? '-1' : '1'
        this.$emit('change', this.params)
      } else {
        this.params.sort = this.field
        this.$emit('change', this.params)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sortable.vue